module.exports = __webpack_public_path__ + "static/img/pic-shuo-3@2x.45a8b57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/pic-shuo-3@2x.png
// module id = 355
// module chunks = 0